import hooks from '../../hooks';
import contentEditable from '../../content-editable';

const documentCopyHandler = (event) => {
  contentEditable.handlers.checkpointDelayHandler(event);
  hooks.handlers.onLiveDocumentCopy(event);

  const { srcElement } = event;
  const closestContentEditable = srcElement.closest('[contenteditable]');

  if (!closestContentEditable) return;

  hooks.handlers.onTextCopy(event);
  contentEditable.handlers.copyHandler(event);
};

export default documentCopyHandler;
